import { AnyAction } from 'redux';
import { combineEpics } from 'redux-observable';

import { appSettingsEpic } from '../features/common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const rootEpic = combineEpics<AnyAction, AnyAction, any>(appSettingsEpic);
